import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootState } from 'types/state'
import ControlMenu from './ControlMenu'
import { useInventoryZoneMenu } from './useInventoryZoneMenu'

import { useFeatureFlag } from '../../util/featureFlags'
import SideBarNavigationMenus from './SideBarNavigationMenus'

// Menu categorized by zone based on current design,...
const useMenuByZone = () => {
  const zone = useSelector((state: RootState) => state.zone)
  const location = useLocation()
  const InventoryZoneMenu = useInventoryZoneMenu()

  const enableInventoryManagement = useFeatureFlag('inventory_management', 'on')
  const enableHwNewSideBar = useFeatureFlag('hardware_new_sidebar', 'on')

  // Hide sidebar on Cart page
  if (location.pathname === '/shop/cart') {
    return null
  }

  if (zone === 'control') {
    return ControlMenu
  } else if (
    enableHwNewSideBar !== false &&
    (zone === 'shop' || zone === 'inventory' || zone === 'manage_orders' || zone === 'quotes')
  ) {
    return SideBarNavigationMenus
  } else if (enableInventoryManagement && (zone === 'shop' || zone === 'inventory')) {
    return InventoryZoneMenu
  }
}

export default useMenuByZone
